import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { paths } from 'config'
import { useLogout, useUserRole } from 'shared/hooks'
import { UserRole } from 'shared/types'

export const useDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return { anchorEl, handleClick, handleClose }
}

export const useOptions = () => {
  const { t } = useTranslation()
  const { isAllowed } = useUserRole()
  const history = useHistory()
  const { handleLogout } = useLogout()
  return [
    {
      title: t('profileDetails'),
      onClick: () => history.push(paths.account),
      role: [UserRole.User],
    },
    {
      title: t('logout'),
      onClick: handleLogout,
    },
  ].filter(item => !item.role || isAllowed(item.role))
}
